import { createFileRoute } from '@tanstack/react-router';
import { PublicationPage } from '@/features/settings/PublicationPage';

export const Route = createFileRoute('/app/settings/publication')({
  component: PublicationPage,
  staticData: { title: 'Publication · Settings' },
});
